//#region src/menu_item_affinity_formula_description.ts
var MenuItemAffinityFormulaDescription = /* @__PURE__ */ function(MenuItemAffinityFormulaDescription) {
	MenuItemAffinityFormulaDescription["OrderedItemCount"] = "ordered-item-count";
	return MenuItemAffinityFormulaDescription;
}(MenuItemAffinityFormulaDescription || {});
//#endregion
export { MenuItemAffinityFormulaDescription };

//# sourceMappingURL=menu_item_affinity_formula_description.js.map